import { zPhoneNumber } from '@harvestiq/zod';
import { z } from '@harvestiq/zod';
import { legacySequelizeUserSchema } from './shared';

const baseRequest = z.object({
  firstName: z.string().trim(),
  lastName: z.string().trim(),
  phone: zPhoneNumber(),
  email: z.string().trim().toLowerCase().email(),
  password: z.string().optional(),
  passwordVerify: z.string().optional(),
  confirmedAt: z.coerce.string().datetime().optional(),
  roles: z.array(z.string().trim()).min(1),
  sendWelcomeEmail: z.boolean().optional(),
});

export const createUserRequestBodySchema = baseRequest.superRefine(
  (val, ctx) => {
    if (
      (!!val.password || !!val.passwordVerify) &&
      val.password !== val.passwordVerify
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Passwords must match',
        path: ['passwordVerify'],
      });
    }
  }
);
export type CreateUserRequestBody = z.infer<typeof createUserRequestBodySchema>;

export const createUserErrorResponseSchema = z.object({
  data: z.array(z.never()).length(0),
  errors: z.array(
    z.object({
      message: z.string(),
    })
  ),
});

export const createUserResponseSchema = z
  .object({
    data: z.object({
      user: legacySequelizeUserSchema,
    }),
  })
  .or(createUserErrorResponseSchema);
export type CreateUserResponse = z.infer<typeof createUserResponseSchema>;
